

import React, { useState, useEffect, useMemo, useCallback } from 'react'; 
import Modal from 'react-modal';
import { fetchHotels } from '../../API/fetchHotels';
import { fetchFactureOrganismes } from '../../API/fetchFactureOrganismes';
import { checkPassportExistence } from '../../API/checkPassportExisting';
import { addClient } from '../../API/ajouterClient';
import { AjouterReservation } from '../../API/ajouterreservation';
import { deleteReservation } from '../../API/deletereservation';
import { fetchReservations } from '../../API/retrievereservations';
import { fetchRoomsHotelFacture } from '../../API/fetchRoomsHotelFacture'; 
import { EditReservation } from '../../API/updatereservation';
import { fetchIDReservation } from '../../API/fetchIdReservation';
import { fetchReservationById } from '../../API/fetchReservationById';







import { factClientCheck } from '../../Functions/factClientCheck';
import { getFormattedDate } from '../../Functions/currentDateFacture';
import { formatedDateClient } from '../../Functions/convertDate';
import { checkReservationOverlap } from '../../Functions/checkReservationOverlap';
import { formatedDBDate } from '../../Functions/convertDate';
import { exportReservationExcel } from '../../Functions/exportReservationExcel';
import { handlePrint } from '../../Functions/printReservationbrowser';






import '../../Css/ReservationTable.css';
import { BsDatabaseDown } from 'react-icons/bs';

















const EditReservations = ({reservations, onClose, isSubmited}) => {
  const [organisme, setOrganisme] = useState([]);
  const [selectedorganisme, setSelectedorganisme] = useState('');
  const [hotelList, setHotelList] = useState([]);
  const [selectedHotel, setSelectedHotel] = useState('');
  const [roomList, setRoomList] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState(''); 
  const [BCReference, setBCReference] = useState(''); 
  const [pension, setPension] = useState(''); 
  //const [reservationStatus, setReservationStatus] = useState(''); 
  const [observations, setObservations] = useState(''); 
  const [currentDate, setCurrentDate] = useState('');
  const [reservationclients, setReservationclients] = useState([{
    passport: '',
    clientName: '',
    checkInDate: '',
    checkOutDate: '',
    BCReference: "",
    reservationStatus: ''
  }]);
  const [reservationData, setReservationData] = useState([]);
  const [notification, setNotification] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  //const [editReservationId, setEditReservationId] = useState(null);
  const [reservationFilters, setReservationFilters] = useState({
      id:"",
      id_reservation: "",
      selectedorganisme: "",
      selectedHotel: "",
      selectedRoom: "",
      pension: "",
      observations: "",
      currentDate: "",
      passport: "",
      clientName: "",
      checkInDate: "",
      checkOutDate: "",
      BCReference: "",
      reservationStatus: "",
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [errorMsg, setErrorMsg] = useState(null);
    const [selectedReservation, setSelectedReservation] = useState(null); // Store the selected reservation
    const [files, setFiles] = useState([]);
    const [fileUrls, setFileUrls] = useState([]);
    const [docUrls, setDocUrls] = useState([]);
    const [overlapMessage, setOverlapMessage] = useState([]);



    const token = localStorage.getItem('token'); // Get token from localStorage
    const apiUrl = process.env.REACT_APP_API_URL;






    


    // Fetch data on component mount
    useEffect(() => {
      const fetchRservationData = async () => {
        const reservationsRes = await fetchReservationById(reservations);
    
        let { clients, filenames } = reservationsRes[0];
        setSelectedorganisme(reservationsRes[0].selectedorganisme);
        setSelectedHotel(reservationsRes[0].selectedHotel);
        setSelectedRoom(reservationsRes[0].selectedRoom);
        setBCReference(reservationsRes[0].BCReference);
        setPension(reservationsRes[0].pension);
        setObservations(reservationsRes[0].observations);
        setCurrentDate(reservationsRes[0].currentDate);
        setReservationclients(clients);
      }
      
      fetchRservationData();
    }, [reservations]);

    



/*Retrieve hotel list*/
  useEffect(() => {
    const fetchHotelData = async () => {
      const data = await fetchHotels();
      setHotelList(data);
    };
    fetchHotelData();
  }, []);





/*Retrieve organisme list*/
  useEffect(() => {
    const fetchOrganismeData = async () => {
      const data = await fetchFactureOrganismes();
      setOrganisme(data);
    };
    fetchOrganismeData();
  }, []);




  const handleRemoveFilee = (index) => {
    setFileUrls((prevDocUrls) => prevDocUrls.filter((_, i) => i !== index)); // Remove file by index
  };




  const fetchReservationsData = async () => {
    try {
      const data = await fetchReservations();

      setReservationData([...data]);
    } catch (error) {
      console.error('Failed to fetch reservations', error);
    } finally {
      setLoading(false);
    }
  };




  useEffect(() => {
    fetchReservationsData();
  }, []);






  useEffect(() => {
    const fetchRoomData = async () => {
      const data = await fetchRoomsHotelFacture(selectedHotel); 
      setRoomList(data); 
    };
    fetchRoomData();
  }, [selectedHotel]);




  

  const handleAddClient = () => {
    setReservationclients([...reservationclients, { passport: '', clientName: '', checkInDate: '', checkOutDate: '', reservationStatus: "", documentUrl:"" }]);
  };

  const handleRemoveClient = async (index) => {
    const updatedClients = reservationclients.filter((_, i) => i !== index);
    setReservationclients(updatedClients);
    await checkReservationOverlap(updatedClients,setOverlapMessage,reservations );
  };

  const handleIputDataChange = async (index, field, value) => {
    const updatedData = [...reservationclients];
    updatedData[index][field] = value;

    await checkReservationOverlap(updatedData,setOverlapMessage,reservations );

    let checkIn=updatedData[index].checkInDate;
    let checkOut=updatedData[index].checkOutDate;

    const passporto = updatedData[index].passport;
  
    if (field === 'passport' ) {
      if(passporto.length === 8){
          factClientCheck(updatedData,setNotification);
      }else{
        updatedData[index].clientName = '';
        setNotification('Le passport doit etre 8 caractére');
      }
    }

    if (field === 'checkInDate' || field === 'checkOutDate') {
      const today = new Date();
      const todayFormatted = today.toISOString().split('T')[0];  
  
      if (checkOut <= todayFormatted) {
        updatedData[index].reservationStatus = 'Check-Out';
      } 
      else if (checkIn > todayFormatted) {
        updatedData[index].reservationStatus = 'Confirmée';
      } 
      else if (  checkIn <= todayFormatted) {
        updatedData[index].reservationStatus = 'Check-In';
      }
    }

    setReservationclients([...updatedData]);
  };




  const handleHotelChange = (event) => {
    setSelectedHotel(event.target.value);
  };

  const handleObservationChange = (event) => {
    setObservations(event.target.value);
  };

  const handleOrganismeChange = (event) => {
    setSelectedorganisme(event.target.value);
    getFormattedDate(setCurrentDate);
  };

  const handleRoomlChange = (event) => {
    setSelectedRoom(event.target.value);
  };




  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const factClientData = reservationclients.map(({ passport, clientName }) => ({
      passport,
      clientName,
    }));

    let doclink = { fileUrls: [], originalFileNames: [] };


    if (fileUrls.length !== 0){
      doclink = await uploadDocuments();
    }
    

    const updatedReservation = {
      reservationclients,
      selectedorganisme,
      selectedHotel,
      selectedRoom,
      BCReference,
      pension,
      observations,
      currentDate,
      docUrls: doclink.fileUrls,
      filenames: doclink.originalFileNames
    };

    try {
      await EditReservation(reservations, updatedReservation);
      for (const client of factClientData) {
        const clientExists = await checkPassportExistence(client.passport);
        if (!clientExists) {
          await addClient(client);
        }
      }
        alert(`Reservation updated successfully ${reservations}`);
        onClose();
        isSubmited();
    } catch (error) {
      console.error('Failed to submit reservation:', error);
    } finally {
      setLoading(false);
    }
  };

  

const handleFileChange = async (e) => {
  const files = e.target.files;

  if (files.length > 0) {
    const formData = new FormData();
    const newFiles = [];
    const maxFileSize = 5 * 1024 * 1024; 

    for (let file of files) {
      if (file.type === "application/pdf") {
        if (file.size > maxFileSize) {
          alert("File is too large. Please upload a file smaller than 5 MB.");
          e.target.value = ""; 
          return; 
        }
        formData.append("files", file);
        newFiles.push(file);
      } else {
        alert("Please upload only JPEG files.");
        e.target.value = ""; 
        return; 
      }
    }
    setFileUrls((prevFiles) => [...prevFiles, ...newFiles]);
    e.target.value = ""; 
  }
};



const uploadDocuments = async () => {
  try {
    const formData = new FormData();

    for (let file of fileUrls) {
      formData.append("files", file);
    }

    const response = await fetch(`${apiUrl}/api/upload/reservation-file`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`, 
      },
      body: formData,
    });

    const data = await response.json();

    if (response.ok) {
      return {
        fileUrls: data.fileUrls,
        originalFileNames: data.originalFileNames
      };
    } else {
      alert("File upload failed");
    }
    
  } catch (error) {
    console.error("Error uploading file:", error);
    alert("Error uploading file");
  } finally {
    setLoading(false);
  }
};

      
   /*     
  if (loading) {
    return <div className='loader'>
        <span style={{ '--i': 1 }}>L</span>
        <span style={{ '--i': 2 }}>o</span>
        <span style={{ '--i': 3 }}>a</span>
        <span style={{ '--i': 4 }}>d</span>
        <span style={{ '--i': 5 }}>i</span>
        <span style={{ '--i': 6 }}>n</span>
        <span style={{ '--i': 7 }}>g</span>
        <span style={{ '--i': 8 }}>.</span>
        <span style={{ '--i': 9 }}>.</span>
        <span style={{ '--i': 10 }}>.</span>
      </div>;
  }*/

  if (error) {
    return <div className='Error-API'>Error: {error}</div>;
  }
  

  return (

    
      <div className="modal-overlay">
        <div className="modal-content">
        <div className="reservation-page">
      <div className="ReservationTable__container">
        <h2 className="Facturetablie__title">Modifier une réservation</h2>

        <form onSubmit={handleSubmit} className="ReservationTable__form">
          {/* Organisme Select */}
          <div className='ReservationTable__flex-block'>
            <div className="ReservationTable__form-group">
              <label>Organisme:</label>
              <select
                name="organisme"
                value={selectedorganisme}
                onChange={handleOrganismeChange}
                required
              >
                <option value="" disabled>اختر الموؤسسة</option>
                {organisme.map((org, index) => (
                  <option key={index} value={org.title}>{org.title}</option>
                ))}
              </select>
            </div>

            {/* Hotel Select */}
            <div className="ReservationTable__form-group">
              <label>Hotel:</label>
              <select
                name="hotels"
                value={selectedHotel}
                onChange={handleHotelChange}
                required
              >
                <option value="" disabled>اختر النزل</option>
                {hotelList.map((hotel, index) => (
                  <option key={index} value={hotel.nameHotel}>{hotel.nameHotel}</option>
                ))}
              </select>
            </div>

            {/* Room Select */}
            <div className="ReservationTable__form-group">
              <label>Chambre:</label>
              <select
                name="rooms"
                value={selectedRoom}
                onChange={handleRoomlChange}
                required
              >
                <option value="" disabled>اختر الغرفة</option>
                {roomList.map((room, index) => (
                  <option key={index} value={room.room}>{room.room}</option>
                ))}
              </select>
            </div>

            {/* Pension Select */}
            <div className="ReservationTable__form-group">
              <label>Arrangement:</label>
              <select
                name="pension"
                value={pension}
                onChange={(e) => setPension(e.target.value)}
                required
              >
                <option value="" disabled>اختر نوع الاقامة</option>
                <option value="اقامة مع فطور صباح">اقامة مع فطور صباح</option>
                <option value="نصف اقامة">نصف اقامة</option>
                <option value="اقامة كاملة">اقامة كاملة</option>
              </select>
            </div>
          </div>


        {Array.isArray(notification) && notification.length > 0 && (
          <div>
            {notification.map((msg, idx) => (
              <p key={idx} style={{ color: 'green', whiteSpace: 'pre-line' }}>
                {msg}
              </p>
            ))}
          </div>
        )}


       {Array.isArray(errorMsg) && errorMsg.length > 0 && (
          <div>
            {errorMsg.map((msg, idx) => (
              <p key={idx} style={{ color: 'red', whiteSpace: 'pre-line' }}>
                {msg}
              </p>
            ))}
          </div>
        )}


        {Array.isArray(overlapMessage) && overlapMessage.length > 0 && (
          <div>
            {overlapMessage.map((msg, idx) => (
              <p key={idx} style={{ color: 'red', whiteSpace: 'pre-line' }}>
                {msg}
              </p>
            ))}
          </div>
        )}

          {reservationclients.length === 0 && handleAddClient()}
          {reservationclients.map((client, index) => (
            <div key={index} className="ReservationTable__form-grid">
              <div className="ReservationTable__form-group2">
                <label>Passport:</label>
                <input
                  type="text"
                  name="passport"
                  value={client.passport}
                  onChange={(e) => handleIputDataChange(index, 'passport', e.target.value.toUpperCase())}
                  required
                />
              </div>
              <div className="ReservationTable__form-group2">
                <label>Nom du Client:</label>
                <input
                  type="text"
                  name="clientName"
                  value={client.clientName}
                  onChange={(e) => handleIputDataChange(index, 'clientName', e.target.value)}
                  required
                />
              </div>
              <div className="ReservationTable__form-group2">
                <label>Check In:</label>
                <input
                  type="date"
                  name="checkInDate"
                  value={client.checkInDate}
                  onChange={(e) => handleIputDataChange(index, 'checkInDate', e.target.value)}
                  required
                />
              </div>
              <div className="ReservationTable__form-group2">
                <label>Check Out:</label>
                <input
                  type="date"
                  name="checkOutDate"
                  value={client.checkOutDate}
                  onChange={(e) => handleIputDataChange(index, 'checkOutDate', e.target.value)}
                  required
                />
              </div>
              <div className="ReservationTable__form-group2">
                <label>B.C# ref:</label>
                <input
                  type="text"
                  name="BCReference"
                  value={client.BCReference}
                  onChange={(e) => handleIputDataChange(index, 'BCReference', e.target.value)}
                />
              </div>
              {isEditing ? (
                <div className="ReservationTable__form-group2">
                  <label>Statut</label>
                  <select
                    name="reservationStatus"
                    value={client.reservationStatus}
                    onChange={(e) => handleIputDataChange(index, 'reservationStatus', e.target.value)}
                  >
                    <option value="">{client.reservationStatus}</option>
                    <option value="annulée">Annulée</option>
                  </select>
                </div>
              ) : null}

              {reservationclients.length > 1 && (
                <div className="ReservationTable__form-group2">
                <button
                  type="button"
                  className="ReservationTable__remove-client-btn"
                  onClick={() => handleRemoveClient(index)}
                >
                  Supprimer
                </button>
              </div>
              )}
            </div>
          ))}

          <button type="button" className="ReservationTable__add-client-btn" onClick={handleAddClient}>
            Ajouter Client
          </button>

          <div className="ReservationTable__form-group3">
            <label>Commentaire</label>
            <input
              name="Commentaire"
              type="text"
              placeholder="write something here ...."
              value={observations}
              onChange={handleObservationChange}
              rows="2"
              cols="2"
            />
          </div>

          {!isEditing && (
            <div className="ReservationTable__file-form-group">
              <label>Joindre le document (PDF uniquement):</label>
              <input
                type="file"
                name="document"
                accept=".pdf"
                multiple
                onChange={handleFileChange}
              />
            </div>
          )}

          <div>
              {fileUrls.length > 0 && (
                <div>
                  <h4>Uploaded Files</h4>
                  <ul className='ReservationTable__fileurls'>
                    {fileUrls.map((file, index) => (
                      <li key={index}>
                        {file.name}{" "}
                        <button type="button" className="ReservationTable__delete-file" onClick={() => handleRemoveFilee(index)}>
                          Delete
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
          </div>
          <div className="Reservation__button-area">
            <button type="button" className="Reservation__cancel-btn" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="Reservation__submit-btn">
              Update Réservation
           </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
  );
  
};

export default EditReservations;



